/**
 * Columbia Tech Nav
 * - Opens drawer when "All Tech" pill is clicked
 * - Category pill click: filter to that category (hide others), show subsection row, pill becomes selected (black + X)
 * - X on selected pill: deselect, show all sections, hide subsection row
 * - Subsection row links: scroll to that subsection
 */
(function () {
  var drawerOpen = false;

  function parseJSONScript(el) {
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function getTechDataFromPage() {
    var sections = document.querySelectorAll('[data-columbia-tech-category-id]');
    var byCategory = {};
    var allTech = [];
    sections.forEach(function (section) {
      var categoryId = section.getAttribute('data-columbia-tech-category-id');
      if (!categoryId) return;
      var script = section.querySelector('script[data-columbia-tech-list]');
      var list = parseJSONScript(script);
      if (!Array.isArray(list)) list = [];
      byCategory[categoryId] = list;
      allTech = allTech.concat(list);
    });
    return { byCategory: byCategory, allTech: allTech };
  }

  function getSubsectionsFromPage() {
    var sections = document.querySelectorAll('[data-columbia-tech-category-id]');
    var byCategory = {};
    sections.forEach(function (section) {
      var categoryId = section.getAttribute('data-columbia-tech-category-id');
      if (!categoryId) return;
      var script = section.querySelector('script[data-columbia-tech-subsections]');
      var list = parseJSONScript(script);
      if (!Array.isArray(list)) list = [];
      byCategory[categoryId] = list;
    });
    return byCategory;
  }

  function deselectSvg() {
    return '<svg width="10" height="10" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function scrollToBelowNav(element, navEl) {
    if (!element || !navEl) return;
    var navHeight = navEl.offsetHeight || 0;
    var isFixed = navEl.classList.contains('is-fixed');
    var fixedPadding = isFixed ? 0 : 20;
    var extraOffset = 10;
    var elementTop = element.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
    var scrollTop = elementTop - navHeight - fixedPadding - extraOffset;
    if (scrollTop < 0) scrollTop = 0;
    window.scrollTo({ top: scrollTop, behavior: 'smooth' });
  }

  function setCategorySelected(navEl, sectionId, subsectionsByCategory) {
    var pills = navEl.querySelectorAll('[data-columbia-tech-nav-category]');
    pills.forEach(function (pill) {
      var sid = pill.getAttribute('data-section-id');
      var deselectEl = pill.querySelector('[data-columbia-tech-nav-deselect]');
      if (sid === sectionId) {
        pill.classList.add('is-selected');
        if (deselectEl) deselectEl.innerHTML = deselectSvg();
      } else {
        pill.classList.remove('is-selected');
        if (deselectEl) deselectEl.innerHTML = '';
      }
    });
    var sections = document.querySelectorAll('[data-columbia-tech-category-id]');
    sections.forEach(function (section) {
      var id = section.getAttribute('data-columbia-tech-category-id');
      if (id === sectionId) {
        section.classList.add('columbia-tech-nav-selected');
        section.style.display = '';
      } else {
        section.classList.remove('columbia-tech-nav-selected');
        section.style.display = 'none';
      }
    });
    document.body.classList.add('columbia-tech-nav-has-selection');
    var subsectionsEl = navEl.querySelector('[data-columbia-tech-nav-subsections]');
    if (subsectionsEl) {
      var list = subsectionsByCategory[sectionId] || [];
      subsectionsEl.innerHTML = '';
      list.forEach(function (sub, index) {
        var a = document.createElement('a');
        a.href = '#' + sub.id;
        a.className = 'columbia-tech-nav__subsection-link';
        a.setAttribute('data-columbia-tech-subsection-id', sub.id);
        a.textContent = sub.label || '';
        if (index === 0) a.classList.add('is-active');
        a.addEventListener('click', function (e) {
          var target = document.getElementById(sub.id);
          if (target) {
            e.preventDefault();
            subsectionsEl.querySelectorAll('.columbia-tech-nav__subsection-link').forEach(function (link) {
              link.classList.remove('is-active');
            });
            a.classList.add('is-active');
            scrollToBelowNav(target, navEl);
          }
        });
        subsectionsEl.appendChild(a);
      });
      subsectionsEl.removeAttribute('hidden');
    }
    var targetSection = document.getElementById('columbia-tech-category-' + sectionId);
    if (targetSection) {
      setTimeout(function () {
        scrollToBelowNav(targetSection, navEl);
      }, 120);
    }
  }

  function clearCategorySelection(navEl) {
    var pills = navEl.querySelectorAll('[data-columbia-tech-nav-category]');
    pills.forEach(function (pill) {
      pill.classList.remove('is-selected');
      var deselectEl = pill.querySelector('[data-columbia-tech-nav-deselect]');
      if (deselectEl) deselectEl.innerHTML = '';
    });
    var sections = document.querySelectorAll('[data-columbia-tech-category-id]');
    sections.forEach(function (section) {
      section.classList.remove('columbia-tech-nav-selected');
      section.style.display = '';
    });
    document.body.classList.remove('columbia-tech-nav-has-selection');
    var subsectionsEl = navEl.querySelector('[data-columbia-tech-nav-subsections]');
    if (subsectionsEl) {
      subsectionsEl.innerHTML = '';
      subsectionsEl.setAttribute('hidden', '');
    }
  }

  function buildMenuContent(navEl, blocks, techData) {
    var menuEl = navEl.querySelector('[data-columbia-tech-nav-menu]');
    if (!menuEl) return;
    menuEl.innerHTML = '';
    var allTech = techData.allTech || [];
    var byCategory = techData.byCategory || {};

    blocks.forEach(function (block, index) {
      var label = block.label || 'Category';
      var sectionId = block.section_id || '';
      var isAllTech = !sectionId;
      var techList = isAllTech ? allTech : (byCategory[sectionId] || []);

      var sectionEl = document.createElement('div');
      sectionEl.className = 'columbia-tech-nav__menu-section';
      sectionEl.setAttribute('data-columbia-tech-nav-menu-section', isAllTech ? 'all' : sectionId);

      var header = document.createElement('button');
      header.type = 'button';
      header.className = 'columbia-tech-nav__menu-section-header';
      header.setAttribute('aria-expanded', isAllTech ? 'true' : 'false');
      header.setAttribute('aria-controls', 'columbia-tech-nav-menu-list-' + index);
      header.setAttribute('id', 'columbia-tech-nav-menu-header-' + index);
      header.innerHTML = '<span class="columbia-tech-nav__menu-section-label">' + escapeHtml(label) + '</span>' +
        '<span class="columbia-tech-nav__menu-section-chevron" aria-hidden="true">' + (isAllTech ? chevronUpSvg() : chevronDownSvg()) + '</span>';
      sectionEl.appendChild(header);

      var listWrap = document.createElement('div');
      listWrap.className = 'columbia-tech-nav__menu-section-content' + (isAllTech ? ' is-expanded' : '');
      listWrap.id = 'columbia-tech-nav-menu-list-' + index;
      listWrap.setAttribute('role', 'region');
      listWrap.setAttribute('aria-labelledby', 'columbia-tech-nav-menu-header-' + index);
      listWrap.setAttribute('aria-hidden', isAllTech ? 'false' : 'true');

      var list = document.createElement('ul');
      list.className = 'columbia-tech-nav__menu-list';
      techList.forEach(function (tech) {
        var li = document.createElement('li');
        var link = document.createElement('a');
        var techAnchor = tech && tech.id ? tech.id : '';
        if (techAnchor) link.href = '#' + techAnchor;
        else if (sectionId) link.href = '#columbia-tech-category-' + sectionId;
        else link.href = '#';
        link.className = 'columbia-tech-nav__menu-link';
        link.textContent = tech.name || '';
        if (tech.handle) link.setAttribute('data-tech-handle', tech.handle);
        link.addEventListener('click', function (e) {
          e.preventDefault();
          scrollToTechFromDrawer(navEl, tech, sectionId);
        });
        li.appendChild(link);
        list.appendChild(li);
      });
      listWrap.appendChild(list);
      sectionEl.appendChild(listWrap);

      header.addEventListener('click', function () {
        var expanded = header.getAttribute('aria-expanded') === 'true';
        header.setAttribute('aria-expanded', !expanded);
        listWrap.classList.toggle('is-expanded', !expanded);
        listWrap.setAttribute('aria-hidden', expanded ? 'true' : 'false');
        var chevron = header.querySelector('.columbia-tech-nav__menu-section-chevron');
        if (chevron) chevron.innerHTML = expanded ? chevronDownSvg() : chevronUpSvg();
      });

      menuEl.appendChild(sectionEl);
    });
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function escapeSelectorAttr(val) {
    if (val === null || val === undefined) return '';
    return String(val).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function resolveTechCardElement(tech, sectionSlug) {
    if (tech && tech.id) {
      var byId = document.getElementById(tech.id);
      if (byId) return byId;
    }
    if (tech && tech.handle) {
      var sel = '.columbia-tech-card[data-tech-handle="' + escapeSelectorAttr(tech.handle) + '"]';
      var card = document.querySelector(sel);
      if (card) return card;
    }
    if (sectionSlug)
      return document.getElementById('columbia-tech-category-' + sectionSlug);
    return null;
  }

  function scrollToTechFromDrawer(navEl, tech, sectionSlug) {
    var targetEl = resolveTechCardElement(tech, sectionSlug);
    if (!targetEl) return;
    var categoryBlock = targetEl.closest('[data-columbia-tech-category-id]');
    if (categoryBlock && window.getComputedStyle(categoryBlock).display === 'none') {
      clearCategorySelection(navEl);
    }
    closeDrawer(navEl);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollToBelowNav(targetEl, navEl);
      });
    });
  }

  function chevronDownSvg() {
    return '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function chevronUpSvg() {
    return '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M9 7.5L6 4.5L3 7.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function openDrawer(navEl) {
    var drawer = navEl.querySelector('[data-columbia-tech-nav-drawer]');
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawerOpen = true;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        var closeBtn = navEl.querySelector('[data-columbia-tech-nav-close]');
        if (closeBtn) closeBtn.focus();
      });
    });
  }

  function closeDrawer(navEl) {
    var drawer = navEl && navEl.querySelector('[data-columbia-tech-nav-drawer]');
    if (!drawer) return;
    var panel = drawer.querySelector('.columbia-tech-nav__panel');
    drawer.classList.remove('is-open');
    var done = false;
    function onTransitionEnd() {
      if (done) return;
      done = true;
      drawer.setAttribute('hidden', '');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var trigger = navEl && navEl.querySelector('[data-columbia-tech-nav-trigger]');
      if (trigger) trigger.focus();
      drawerOpen = false;
    }
    if (panel) {
      panel.addEventListener('transitionend', onTransitionEnd, { once: true });
      setTimeout(onTransitionEnd, 450);
    } else {
      onTransitionEnd();
    }
  }

  function setupStickyNav(navEl) {
    var placeholder = document.createElement('div');
    placeholder.className = 'columbia-tech-nav__placeholder';
    navEl.parentNode.insertBefore(placeholder, navEl.nextSibling);

    var navOriginalTop = navEl.getBoundingClientRect().top + window.pageYOffset;
    var isFixed = false;

    function onScroll() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollY >= navOriginalTop && !isFixed) {
        placeholder.style.height = navEl.offsetHeight + 'px';
        placeholder.classList.add('is-visible');
        navEl.classList.add('is-fixed');
        isFixed = true;
      } else if (scrollY < navOriginalTop && isFixed) {
        navEl.classList.remove('is-fixed');
        placeholder.classList.remove('is-visible');
        placeholder.style.height = '';
        isFixed = false;
      }
    }

    function recalc() {
      if (isFixed) {
        navEl.classList.remove('is-fixed');
        placeholder.classList.remove('is-visible');
        placeholder.style.height = '';
        isFixed = false;
      }
      navOriginalTop = navEl.getBoundingClientRect().top + window.pageYOffset;
      onScroll();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', recalc);
    onScroll();
  }

  function init() {
    var subsectionsByCategory = getSubsectionsFromPage();
    var navs = document.querySelectorAll('[data-columbia-tech-nav]');
    navs.forEach(function (navEl) {
      var blocksScript = navEl.querySelector('script[data-columbia-tech-nav-blocks]');
      var blocks = parseJSONScript(blocksScript);
      if (!Array.isArray(blocks) || blocks.length === 0) return;

      var techData = getTechDataFromPage();
      buildMenuContent(navEl, blocks, techData);

      setupStickyNav(navEl);

      var trigger = navEl.querySelector('[data-columbia-tech-nav-trigger]');
      if (trigger) {
        trigger.addEventListener('click', function () {
          trigger.setAttribute('aria-expanded', 'true');
          openDrawer(navEl);
        });
      }

      navEl.querySelectorAll('[data-columbia-tech-nav-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var t = navEl.querySelector('[data-columbia-tech-nav-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
          closeDrawer(navEl);
        });
      });

      navEl.querySelectorAll('[data-columbia-tech-nav-category]').forEach(function (pill) {
        pill.addEventListener('click', function (e) {
          if (e.target.closest('[data-columbia-tech-nav-deselect]')) {
            e.preventDefault();
            e.stopPropagation();
            clearCategorySelection(navEl);
            return;
          }
          if (pill.classList.contains('is-selected')) return;
          var sectionId = pill.getAttribute('data-section-id');
          if (sectionId) setCategorySelected(navEl, sectionId, subsectionsByCategory);
        });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openNav = document.querySelector('[data-columbia-tech-nav-drawer]:not([hidden])');
      if (!openNav) return;
      var navEl = openNav.closest('[data-columbia-tech-nav]');
      if (navEl) {
        var t = navEl.querySelector('[data-columbia-tech-nav-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
        closeDrawer(navEl);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
